import { dataBuilding } from 'dls-icons-data'
import { createIcon } from '../common'

const IconBuilding = /*#__PURE__*/createIcon(dataBuilding)
export default IconBuilding
